export default "__VITE_ASSET__kB7dgLa6__"